import {useSelector} from 'react-redux';
import splitRoomString from '@stencil/hotels-utils/src/split-room-string';
import {roomStringSelectorFn} from '@stencil/hotels-common-reducer/src/selectors';
import MultiRoomHeading from '../../Shared/MultiRoomHeading/MultiRoomHeading';
import {getAdultandChildTxt} from '@stencil/hotels-utils/src/common-utils';

export default function RecommendedComboHeading() {
  let roomString = useSelector(roomStringSelectorFn);
  const {roomCount, paxCount, childCount} = splitRoomString(roomString);

  const txt = 'Recommended for ' + getAdultandChildTxt(paxCount, childCount);

  return <MultiRoomHeading headingText={txt} />;
}
